// App Imports
import * as anonymousRoutes from './anonymous'

// Anonymous routes
export default {
    ...anonymousRoutes
}
